import { css } from '@emotion/css';
import styled from '@emotion/styled';
import { colors, FooterCell, Typography } from '@ui-components/neo.tax';
import { Cell } from 'react-table';

const borderLeftClassName = css({ borderLeft: `1px solid ${colors.gray[200]}` });
const borderRightClassName = css({ borderRight: `1px solid ${colors.gray[200]}` });
const selectedRowClassName = css({ backgroundColor: colors.gray[200], color: colors.gray[900] });
const selectedRowDarkenedClassName = css({ backgroundColor: colors.gray[400], color: colors.white });
const unselectedRowClassName = css({ backgroundColor: colors.white, color: colors.gray[500] });
const unselectedRowDarkenedClassName = css({ backgroundColor: colors.gray[50], color: colors.gray[500] });
const alternatingRowClassName = css({ backgroundColor: colors.gray[50], color: colors.gray[500] });
const alternatingRowDarkenedClassName = css({ backgroundColor: colors.gray[100], color: colors.gray[500] });

export const customCellClassNames = <Row extends object>(cell: Cell<Row>): Record<string, boolean>[] => {
  const isDarkenedColumn = ['amountCents', 'qreRdPercentage'].includes(cell.column.id);
  const isEvenRow = cell.row.index % 2 === 0;
  return [
    {
      [borderLeftClassName]: cell.column.id === 'amountCents',
      [borderRightClassName]: cell.column.id === 'qreRdPercentage',
      [selectedRowClassName]: cell.row.isSelected && !isDarkenedColumn,
      [selectedRowDarkenedClassName]: cell.row.isSelected && isDarkenedColumn,
      [unselectedRowClassName]: !cell.row.isSelected && !isDarkenedColumn && isEvenRow,
      [unselectedRowDarkenedClassName]: !cell.row.isSelected && isDarkenedColumn && isEvenRow,
      [alternatingRowClassName]: !cell.row.isSelected && !isDarkenedColumn && !isEvenRow,
      [alternatingRowDarkenedClassName]: !cell.row.isSelected && isDarkenedColumn && !isEvenRow,
    },
  ];
};

export const FooterCellStyled = styled(FooterCell)({
  fontSize: '0.75rem',
});

/**
 * Certain cells that should have right aligned text cannot because the parent element is owned by the `Table` component
 * which is using `style={{ display: 'flex' }}` and therefore cannot be easily modified. Easiest workarounds are to wrap
 * in another component like `<Stack fullWidth>` or style it here and adjust the width or flex-grow.
 */
export const TypographyFullWidth = styled(Typography)({
  width: '100%',
});
